import React from "react";

import { Icon, Functions } from "rhombus-react";
import ReactTooltip from "react-tooltip";

import { getVersionGenSelectedPreview } from "utils/Flags";

import "./ImageItem.css";

export default function ImageItem({
	src = "",
	index = 0,
	variableName = "",
	onRemove = Functions.noop,
}){
	let isAIDevEnabled = getVersionGenSelectedPreview()
		, tooltip = null
		;

	if(isAIDevEnabled){
		tooltip = (
			<ReactTooltip id={`ai-tooltip-preview-${index}`} className="asset-tooltip-preview">
				<img src={src} alt="thumbnail" className="tooltip-image" />
			</ReactTooltip>
		);
	}

	return (
		<figure className="ai-image-asset image-option cypress-gen-ai-image-asset" data-tip data-for={`ai-tooltip-preview-${index}`}>
			<img src={src} alt="thumbnail" className="image-preview" />
			{tooltip}
			<div className="trash-receptacle">
				<Icon
					name="far fa-trash-alt"
					className={`trash-receptacle-icon cypress-gen-ai-delete-${variableName.toLowerCase()}-${index}`}
					data-tip="Delete"
					onClick={() => { onRemove(variableName, src); }}
				/>
			</div>
		</figure>
	);
}

ImageItem.displayName = "ImageItem";
